


































import { Component, Prop, Vue } from 'vue-property-decorator';

import { FuelLabel } from '@/common/fuels';
import { WraLoader } from '@/common/loader';
import { Fuel } from '@/models/fuel.model';
import IndexPageDailyReportList from '@/pages/index/pages/index/components/IndexPageDailyReportList.vue';
import IndexPageDailyReportTable from '@/pages/index/pages/index/components/IndexPageDailyReportTable.vue';
import { DailyReportStore } from '@/store/dailyReport';

@Component({
  components: {
    FuelLabel,
    IndexPageDailyReportList,
    IndexPageDailyReportTable,
    WraLoader,
  },
})
export default class IndexPageDailyReportCard extends Vue {
  @Prop() fuel!: Fuel;
  @DailyReportStore.Bind.State isFetching!: DailyReportStore.State<'isFetching'>;
  @DailyReportStore.Bind.Getter('byFuel') dailyReportsByFuel!: DailyReportStore.Getters<'byFuel'>;

  get isTemperatureShown() {
    return !!this.fuel.tanks.find(m => m.ast);
  }
}
